// removed by extract-text-webpack-plugin
module.exports = {"image":"_3TrZb9K40l-xJKpBG5DMkW","message":"_2nFxsnGXxNIV6PW3RqeMDp"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/HelpDialogContent/HelpDialogContent.css
// module id = 733
// module chunks = 3